import { ISearchPage, IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";

interface IToday {
    distinguishNum: number,   // 2 识别
    filterNum: number,   // -1g 过滤
    releaseNum: number,   // 1  发布
    signNum: number,   // 0 标记
}

export interface IKeyWordsPieType {
    map: object,
    name: string,
    value: number
}

export interface IWeekLineType {
    distinguishNum: number,  // 3
    filterNum: number,   // -1
    week: string, // "周一"
}
export interface IMonthLineType {
    distinguishNum: number,  // 3
    filterNum: number,   // -1
    month: string, // "周一"
}
export interface IWebSiteBarType {
    distinguishNum: number,       // 0
    filterNum: number,       // 0
    name: string,       // "百度"
    releaseNum: number,       // 0
    signNum: number,       // 0
}

export interface IprogressType {
    map: string,  // {}
    name: string,  // "斯堪尼亚"
    num: number,  // 0
}
export interface IWordList {
    distinguishNum: number,  // 105
    filterNum: number,  // 2409
    name: string,  // "中国交建"
    releaseNum: number,  // 2514
    signNum: number,  // 0
}

export interface IWordCloudType {
    code: string,   // null
    createTime: string,   // "2021-05-27 21:string,   //41:string,   //20"
    createUser: string,   // "管理员"
    deleteFlag: string,   // 0
    id: string,   // "3ea0b3ffae238143a575894f0fedbe2f"
    keywordTypeId: string,   // "4a82a8d9b40c61703b76fdfe33161a84"
    keywordTypeName: string,   // "车"
    list: IWordList[],   // []
    name: string,   // "渣土车"
    status: string,   // "1"
    updateTime: string,   // "2021-05-27 21:string,   //41:string,   //20"
    updateUser: string,   // null
    weight: number,   // 0
}
class HomeService {
    //今日获取的信息数量
    async todayStatistics() {
        const apiUrl = `/home/todayStatistics`;
        return await httpRequest.get<IToday>(apiUrl);
    }
    //周
    async weekStatistics() {
        const apiUrl = `/home/weekStatistics`;
        return await httpRequest.get<IWeekLineType[]>(apiUrl);
    }
    //月
    async monthStatistics() {
        const apiUrl = `/home/monthStatistics`;
        return await httpRequest.get<IMonthLineType[]>(apiUrl);
    }
    //关键词
    async keyWordStatistics() {
        const apiUrl = `/home/keyWordStatistics`;
        return await httpRequest.get<IKeyWordsPieType[]>(apiUrl);
    }
    //
    async webSiteStatistics() {
        const apiUrl = `/home/webSiteStatistics`;
        return await httpRequest.get<IWebSiteBarType[]>(apiUrl);
    }
    //词云
    async wordCloudStatistics() {
        const apiUrl = `keyword/keywordStatisticsAndWeb`;
        return await httpRequest.get<IWordCloudType[]>(apiUrl);
    }
    //进度跳
    async progressStatistics() {
        const apiUrl = `home/webSiteAnalysisStatistics`;
        return await httpRequest.get<IPage<IprogressType>>(apiUrl);
    }
}
export const homeService = new HomeService();